import { render, staticRenderFns } from "./newClient.vue?vue&type=template&id=4518dfb8&"
import script from "./newClient.vue?vue&type=script&lang=js&"
export * from "./newClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports